import { apiWithProject } from './greenetworkAPI';

const END_POINT = '/devices';

const addMachine = (id) => apiWithProject.post(`${END_POINT}/${id}`, {
    class: 'Machine',
    function: 'Basic',
    displayName: id,

});

const getMachine = (id) => apiWithProject.get(`${END_POINT}/${id}`);

const updateOperationalSpecs = (id, data) => apiWithProject.put(`${END_POINT}/${id}`, {
    class: 'Machine',
    function: 'OperationalSpecs',
    data
});

const updateTechnicalData = (id, data) => apiWithProject.put(`${END_POINT}/${id}`, {
    class: 'Machine',
    function: 'TechnicalSpecs',
    data
});

const updateMaintenanceInformation = (id, data) => apiWithProject.put(`${END_POINT}/${id}`, {
    class: 'Machine',
    function: 'maintenanceInformation',
    data
});

const deleteMachine = (id) => apiWithProject.delete(`${END_POINT}/${id}`);


const Machine = {
    addMachine,
    getMachine,
    updateOperationalSpecs,
    updateTechnicalData,
    updateMaintenanceInformation,
    deleteMachine
}

export default Machine;